import { render, staticRenderFns } from "./FactoryType.vue?vue&type=template&id=2aa5e61c&scoped=true&"
import script from "./FactoryType.vue?vue&type=script&lang=js&"
export * from "./FactoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5e61c",
  null
  
)

export default component.exports